<template>
  <div style="display: contents">
    <div
      :class="{ 'flex-column': $vuetify.display.smAndDown && !isConnectionStatusInactive }"
      class="d-flex flex-sm-row wrapper"
    >
      <slot name="icon" />
      <slot name="text" />
    </div>

    <div
      v-if="isConnectionStatusActive || !isConnectionStatusInactive"
      class="api-key-card__actions mr-md-1"
    >
      <template v-if="isConnectionStatusActive">
        <div
          v-if="!loading"
          class="d-flex justify-space-between"
        >
          <div class="stats mr-1 mr-md-2">
            <span class="mdi mdi-phone stats-item" />
            <span class="stats-item value">{{ totalCalls }}</span>
          </div>
          <div class="stats">
            <span class="mdi mdi-calendar-blank stats-item" />
            <span class="stats-item value">{{ totalScheduledCalls }}</span>
          </div>
        </div>
        <Loader
          v-else
          size="50"
          thickness="6"
        />
      </template>
      <template v-else-if="!isConnectionStatusInactive">
        <img
          :src="icon"
          alt=""
          aria-hidden="true"
        />
        <p class="sr-only">{{ $t('dashboard.konstantine.create-api.subtitle-turn-on') }}!</p>
      </template>
    </div>

    <v-switch
      v-if="!isConnectionStatusInactive"
      density="compact"
      color="#189D7E"
      hide-details
      :model-value="isConnectionStatusActive"
      :aria-label="$t('dashboard.konstantine.create-api.toggle')"
      @update:model-value="updateAiAgentSwitch"
    />
  </div>
</template>

<script setup lang="ts">
import { useQuery } from '@vue/apollo-composable'
import { computed } from 'vue'

import icon from '@/assets/img/konstantine/turn-it-on.png'
import Loader from '@/modules/dashboard/dashboardDetails/shared/loader.vue'

import GET_ANALYSIS_METRICS from './queries/GetAnalysisMetrics.gql'

const props = defineProps({
  status: String,
})

const isConnectionStatusActive = computed(() => props?.status === 'ACTIVE')
const isConnectionStatusInactive = computed(() => props?.status === 'INACTIVE')

const { result: statisticsResult, loading } = useQuery(GET_ANALYSIS_METRICS, null, {
  enabled: isConnectionStatusActive.value,
})

const totalCalls = computed(() => {
  return statisticsResult.value?.konstantine?.getAnalysisMetrics?.totalCalls || 0
})
const totalScheduledCalls = computed(() => {
  return statisticsResult.value?.konstantine?.getAnalysisMetrics?.totalScheduledCalls || 0
})

const emit = defineEmits(['update-ai-agent-switch'])

const updateAiAgentSwitch = async (value: boolean) => {
  emit('update-ai-agent-switch', value)
}
</script>

<style scoped>
.stats-item {
  display: flex;
  justify-content: center;
  color: #189d7e;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0px;
}
.value {
  color: #414142;
}
.stats {
  width: 80px;
  height: 80px;
  border-radius: 30px;
  opacity: 1;
  background-color: #ffffff;
  padding-top: 10px;
  align-content: center;
}

.api-key-card__actions {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: auto;
  z-index: 9;
}

.sr-only {
  font-family: lobster, sans-serif;
  color: #414142;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.5px;
  text-align: center;
  vertical-align: middle;
  align-self: center;
}
:deep(.v-switch__track) {
  opacity: 1 !important;
  background-color: #ffffff !important;
}
@media (max-width: 460px) {
  .stats {
    width: 70px;
    height: 70px;
  }
  .api-key-card__actions {
    margin-left: 0;
    margin-right: 2px;
  }
}
</style>
